module.exports = __webpack_public_path__ + "static/phsd-logo-6dae969c8fc1de2943ddefe2a0ea072e.jpeg";